
import React from 'react'

import useTranslation from '@/Hooks/UseTranslation'

import './WeekNavigator.scss'

interface Props {
  prev: string
  next: string
  current: string | number
  label?: string
  range?: string
  onChangeWeek: (week?: string) => void
}

const WeekNavigator = (props: Props) => {

  const { prev, next, current, label, range, onChangeWeek } = props

  const { t } = useTranslation()

  return (
    <div className={`week-navigator ${label ? 'pl4-cnc-week-control' : ''}`}>
      <button
        type="button"
        className={`btn btn-link btn-navigator btn-prev ${!prev && 'disabled'}`}
        disabled={!prev}
        onClick={() => onChangeWeek && onChangeWeek(prev)}
        aria-label={t('RESOURCES_CNC:ToolbarPreviousButton')}
        title={t('RESOURCES_CNC:ToolbarPreviousButton')}
      >
        <i className="icon-anterior" aria-hidden="true"></i>
        {!label && <span className="d-none d-md-inline"> {t('RESOURCES_CNC:ToolbarPreviousButton')}</span>}
      </button>
      <button
        type="button"
        className="btn btn-link btn-navigator btn-current"
        disabled={!!label && !current}
        onClick={() => onChangeWeek && onChangeWeek()}
        aria-label={label ? `${label}${range ? `, ${range}` : ''}. ${t('SYSTEM:CurrentWeekButton')}` : t('SYSTEM:CurrentWeekButton')}
        title={t('SYSTEM:CurrentWeekButton')}
      >
        <i className="icon-semana_actual" aria-hidden="true"></i>
        {label && (
          <span className="pl4-cnc-week-control__label">
            <span>{label}{range && <> <span aria-hidden="true">·</span> <span>{range}</span></>}</span>
            <span className="pl4-cnc-week-control__hint">{t('SYSTEM:CurrentWeekButton')}</span>
          </span>
        )}
      </button>
      <button
        type="button"
        className={`btn btn-link btn-navigator btn-next ${!next && 'disabled'}`}
        disabled={!next}
        onClick={() => onChangeWeek && onChangeWeek(next)}
        aria-label={t('RESOURCES_CNC:ToolbarNextButton')}
        title={t('RESOURCES_CNC:ToolbarNextButton')}
      >
        {!label && <span className="d-none d-md-inline">{t('RESOURCES_CNC:ToolbarNextButton')} </span>}
        <i className="icon-siguiente" aria-hidden="true"></i>
      </button>
    </div>
  )
}

export default WeekNavigator
